<script>
	import { Router, beforeUrlChange } from "@roxi/routify";
	import { routes } from "../.routify/routes";
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";

	let loadedPage;
	$beforeUrlChange((event, route) => {
		setTimeout(() => {
			loadedPage = route.title + " page loaded.";
		}, 100);
		return true;
	});
</script>

<div class="wrapper">
	<Navbar />
	<Router {routes} />
	<Footer />
</div>
<div role="alert" class="sr-only">
	{#if loadedPage}
		{loadedPage}
	{/if}
</div>
